import { useTranslation } from 'react-i18next';
import Styles from './NoResults.module.scss';

export interface NoResultsProps {
    filterTooBroad?: boolean;
}

export function NoResults({ filterTooBroad }: Readonly<NoResultsProps>): React.ReactElement {
    const { t } = useTranslation();
    const messageKey = filterTooBroad ? 'Worklist.Filter.ApplyMoreSpecificFilter' : 'NoResultsFound';

    return (
        <tr className={Styles.noResult}>
            <td colSpan={50}>{t(messageKey)}</td>
        </tr>
    );
}
